// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"daf2e2c2","455":"ed60277a","977":"e24e3b64"}[chunkId] + ".chunk.js";
};